import { render } from "./ViewIdea.vue?vue&type=template&id=50d21838"
import script from "./ViewIdea.vue?vue&type=script&lang=js"
export * from "./ViewIdea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__